/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconSettingsShare = createSolidComponent("settings-share", "IconSettingsShare", [
  [
    "path",
    {
      d: "M12.004 21c-.732 .002 -1.466 -.437 -1.679 -1.317a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.306 .317 1.64 1.78 1.004 2.684"
    }
  ],
  ["path", { d: "M12 15a3 3 0 1 0 0 -6a3 3 0 0 0 0 6z" }],
  ["path", { d: "M16 22l5 -5" }],
  ["path", { d: "M21 21.5v-4.5h-4.5" }]
]);

export { IconSettingsShare as default };
//# sourceMappingURL=IconSettingsShare.js.map
